module.exports = __webpack_public_path__ + "static/media/CreativeIdeation.835992f2.png";